var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMemberImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 88,
    viewBox: "0 0 296 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H290C293.314 0 296 2.68629 296 6V88H0V6Z",
    fill: "#F3E9FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M141 44.0002C143.475 44.0002 145.849 43.0168 147.6 41.2665C149.35 39.5162 150.333 37.1422 150.333 34.6668C150.333 32.1915 149.35 29.8175 147.6 28.0672C145.849 26.3168 143.475 25.3335 141 25.3335C138.525 25.3335 136.151 26.3168 134.4 28.0672C132.65 29.8175 131.667 32.1915 131.667 34.6668C131.667 37.1422 132.65 39.5162 134.4 41.2665C136.151 43.0168 138.525 44.0002 141 44.0002ZM137.668 47.5002C130.485 47.5002 124.667 53.3189 124.667 60.5012C124.667 61.697 125.636 62.6668 126.832 62.6668H155.168C156.364 62.6668 157.333 61.697 157.333 60.5012C157.333 53.3189 151.515 47.5002 144.332 47.5002H137.668Z",
    fill: "#7527B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.417 43.4167V48.0833C161.417 49.0531 162.197 49.8333 163.167 49.8333C164.136 49.8333 164.917 49.0531 164.917 48.0833V43.4167H169.583C170.553 43.4167 171.333 42.6365 171.333 41.6667C171.333 40.6969 170.553 39.9167 169.583 39.9167H164.917V35.25C164.917 34.2802 164.136 33.5 163.167 33.5C162.197 33.5 161.417 34.2802 161.417 35.25V39.9167H156.75C155.78 39.9167 155 40.6969 155 41.6667C155 42.6365 155.78 43.4167 156.75 43.4167H161.417Z",
    fill: "#7527B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMemberImage);
export default __webpack_public_path__ + "static/media/add-member-image.2175c532cd3f51c32b00cdcdb10eb02c.svg";
export { ForwardRef as ReactComponent };